import React from 'react'
import PropTypes from 'prop-types'
import UserItem from "./UserItem"

UserBody.propTypes = {
    error: PropTypes.string,
    listUsers: PropTypes.array
}

function UserBody(props) {
    const {error, listUsers, arrSelected, onSelected, onShowEdit} = props

    return (
        <tbody className="CustomersBody">
        {
            !!listUsers && listUsers.length > 0 ? listUsers.map((item, index) => (
                <UserItem
                    key={index}
                    item={item}
                    arrSelected={arrSelected}
                    onSelected={onSelected}
                    onShowEdit={onShowEdit}
                />
            )) : <tr className="NoRecord">
                <td colSpan={6}>Không có bản ghi nào.</td>
            </tr>
        }

        {
            !!error && error.length > 0 && <tr className="NoRecord Error">
                <td colSpan={6}>{error}</td>
            </tr>
        }
        </tbody>
    )
}

export default UserBody
